enum Scenarios {
  new = 'new',
  renew = 'renew',
  reset = 'reset',
}

export default Scenarios;
